<template>
  <div>
    <v-row class="user_register_container">
      <v-col cols="12" xs="12">
        <v-form>
          <form-message v-if="message" :message="message" @close="messageClose">
          </form-message>
          <v-row>
            <v-col cols="12" class="user_register_container_title" style="font-size: 20px;">
              DATOS PERSONALES DEL MENOR DE EDAD
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field filled label="Primer nombre" v-model="PrimerNombre" disabled>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field filled label="Segundo nombre" v-model="SegundoNombre" disabled>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field filled label="Apellido paterno" v-model="apellidoPaterno" disabled>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field filled label="Apellido materno" v-model="apellidoMaterno" disabled>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-select :items="genderList" v-model="Genero" label="Género" filled item-text="name" disabled>
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="fechaNacimientoFormatted" filled label="Fecha de nacimiento" readonly
                    v-bind="attrs" v-on="on" disabled></v-text-field>
                </template>
                <v-date-picker v-model="fechaNacimiento2" no-title @input="menu1 = false" :max="maxDate"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-select :items="documentTypeList" v-model="TipoDocumentoIdentidad" label="Tipo de documento" filled
                return-object item-text="name" disabled>
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field ref="DocumentoIdentidad" filled label="N.º de documento" v-model="DocumentoIdentidad" required
                @keypress="isDocument($event)" disabled>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-select :items="tiposVia" v-model="tipoVia" label="Tipo de Vía" filled return-object item-text="Value"
                required :error-messages="tipoViaError" @input="$v.tipoVia.$touch()" @blur="$v.tipoVia.$touch()">
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field filled label="Dirección" v-model="Direccion1" required :error-messages="Direccion1Error"
                @input="$v.Direccion1.$touch()" @blur="$v.Direccion1.$touch()">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-select :items="departamentos" v-model="departamento" label="Departamento" filled return-object
                item-text="Value" required :error-messages="departamentoError" @input="$v.departamento.$touch()"
                @blur="$v.departamento.$touch()">
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-select :items="provincias" v-model="provincia" label="Provincia" filled return-object item-text="Value"
                required :error-messages="provinciaError" @input="$v.provincia.$touch()" @blur="$v.provincia.$touch()">
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-select :items="distritos" v-model="distrito" label="Distrito" filled return-object item-text="Value"
                required :error-messages="distritoError" @input="$v.distrito.$touch()" @blur="$v.distrito.$touch()">
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field filled label="Celular del Padre" v-model="ApoCelular"
                @keypress="isPhoneNumber($event, ApoCelular)" required :error-messages="ApoCelularError"
                @input="$v.ApoCelular.$touch()" @blur="$v.ApoCelular.$touch()">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field filled label="Teléfono del padre de familia del menor" v-model="ApoTelefono" required
                :error-messages="ApoTelefonoError" @input="$v.ApoTelefono.$touch()" @blur="$v.ApoTelefono.$touch()">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field filled label="Otro celular del contacto" v-model="ApoSegCelular"
                @keypress="isPhoneNumber($event, ApoSegCelular)" required :error-messages="ApoSegCelularError"
                @input="$v.ApoSegCelular.$touch()" @blur="$v.ApoSegCelular.$touch()">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field filled label="Correo electrónico" v-model="CorreoPersonal" required
                :error-messages="CorreoPersonalError" @input="$v.CorreoPersonal.$touch()"
                @blur="$v.CorreoPersonal.$touch()">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field filled label="Colegio" v-model="ColegioMen" required :error-messages="ColegioMenError"
                @input="$v.ColegioMen.$touch()" @blur="$v.ColegioMen.$touch()">
              </v-text-field>
            </v-col>
            <v-col cols="12" class="user_register_container_title" style="font-size: 20px;">
              DATOS PERSONALES DEL PADRE DE FAMILIA
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="NombreResponsable">
              <v-text-field filled label="Nombre Completo" v-model="NombreResponsable" disabled>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="!NombreResponsable">
              <v-text-field filled label="Primer nombre" v-model="primerNombrePadre" required
                :error-messages="primerNombrePadreError" @input="$v.primerNombrePadre.$touch()"
                @blur="$v.primerNombrePadre.$touch()">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="!NombreResponsable">
              <v-text-field filled label="Segundo nombre" v-model="segundoNombrePadre" required
                :error-messages="segundoNombrePadreError" @input="$v.segundoNombrePadre.$touch()"
                @blur="$v.segundoNombrePadre.$touch()">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="!NombreResponsable">
              <v-text-field filled label="Apellido paterno" v-model="apellidoPaternoPadre" required
                :error-messages="apellidoPaternoPadreError" @input="$v.apellidoPaternoPadre.$touch()"
                @blur="$v.apellidoPaternoPadre.$touch()">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="!NombreResponsable">
              <v-text-field filled label="Apellido materno" v-model="apellidoMaternoPadre" required
                :error-messages="apellidoMaternoPadreError" @input="$v.apellidoMaternoPadre.$touch()"
                @blur="$v.apellidoMaternoPadre.$touch()">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-select :items="genderList" v-model="ApoGenero" label="Género" filled item-text="name"
                :error-messages="ApoGeneroError" @input="$v.ApoGenero.$touch()" @blur="$v.ApoGenero.$touch()">
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="apoFechNacFormatted" filled label="Fecha de nacimiento" readonly v-bind="attrs"
                    v-on="on" required :error-messages="apoFechNacError" @input="$v.apoFechNac2.$touch()"
                    @blur="$v.apoFechNac2.$touch()"></v-text-field>
                </template>
                <v-date-picker v-model="apoFechNac2" no-title @input="menu2 = false" :max="maxDate"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-select :items="documentTypeList" v-model="ApoTipoDoc" label="Tipo de documento" filled return-object
                item-text="name" required :error-messages="ApoTipoDocError" @input="$v.ApoTipoDoc.$touch()"
                @blur="$v.ApoTipoDoc.$touch()">
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field filled label="Número de documento" v-model="DNIPadreFamilia" required
                :error-messages="DNIPadreFamiliaError" @input="$v.DNIPadreFamilia.$touch()"
                @blur="$v.DNIPadreFamilia.$touch()" @keypress="isDocument($event, DNIPadreFamilia, ApoTipoDoc)">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field filled label="Correo" v-model="ApoCorreoPer" required :error-messages="ApoCorreoPerError"
                @input="$v.ApoCorreoPer.$touch()" @blur="$v.ApoCorreoPer.$touch()">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field filled label="Correo adicional" v-model="ApoCorreoTrab" required
                :error-messages="ApoCorreoTrabError" @input="$v.ApoCorreoTrab.$touch()" @blur="$v.ApoCorreoTrab.$touch()">
              </v-text-field>
            </v-col>
            <v-col cols="12" class="user_register_container_title" style="font-size: 20px;">
              DATOS PERSONALES DEL OTRO APODERADO
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="ApoSegNombreResponsable">
              <v-text-field filled label="Nombre Completo" v-model="ApoSegNombreResponsable" disabled>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="!ApoSegNombreResponsable">
              <v-text-field filled label="Primer nombre" v-model="primerNombreApoderado" required
                :error-messages="primerNombreApoderadoError" @input="$v.primerNombreApoderado.$touch()"
                @blur="$v.primerNombreApoderado.$touch()">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="!ApoSegNombreResponsable">
              <v-text-field filled label="Segundo nombre" v-model="segundoNombreApoderado" required
                :error-messages="segundoNombreApoderadoError" @input="$v.segundoNombreApoderado.$touch()"
                @blur="$v.segundoNombreApoderado.$touch()">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="!ApoSegNombreResponsable">
              <v-text-field filled label="Apellido paterno" v-model="apellidoPaternoApoderado" required
                :error-messages="apellidoPaternoApoderadoError" @input="$v.apellidoPaternoApoderado.$touch()"
                @blur="$v.apellidoPaternoApoderado.$touch()">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="!ApoSegNombreResponsable">
              <v-text-field filled label="Apellido materno" v-model="apellidoMaternoApoderado" required
                :error-messages="apellidoMaternoApoderadoError" @input="$v.apellidoMaternoApoderado.$touch()"
                @blur="$v.apellidoMaternoApoderado.$touch()">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-select :items="genderList" v-model="ApoSegGenero" label="Género" filled item-text="name"
                :error-messages="ApoSegGeneroError" @input="$v.ApoSegGenero.$touch()" @blur="$v.ApoSegGenero.$touch()">
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="apoSegFechNacFormatted" filled label="Fecha de nacimiento" readonly v-bind="attrs"
                    v-on="on" required :error-messages="apoSegFechNacError" @input="$v.apoSegFechNac2.$touch()"
                    @blur="$v.apoSegFechNac2.$touch()"></v-text-field>
                </template>
                <v-date-picker v-model="apoSegFechNac2" no-title @input="menu3 = false" :max="maxDate"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-select :items="documentTypeList" v-model="ApoSegTipoDoc" label="Tipo de documento" filled return-object
                item-text="name" required :error-messages="ApoSegTipoDocError" @input="$v.ApoSegTipoDoc.$touch()"
                @blur="$v.ApoSegTipoDoc.$touch()">
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field filled label="Número de documento" v-model="ApoSegDNIResponsable" required
                :error-messages="ApoSegDNIResponsableError" @input="$v.ApoSegDNIResponsable.$touch()"
                @blur="$v.ApoSegDNIResponsable.$touch()" @keypress="
                  isDocument($event, ApoSegDNIResponsable, ApoSegTipoDoc)
                  ">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field filled label="Correo" v-model="ApoSegCorreoPer" required
                :error-messages="ApoSegCorreoPerError" @input="$v.ApoSegCorreoPer.$touch()"
                @blur="$v.ApoSegCorreoPer.$touch()">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field filled label="Correo adicional" v-model="ApoSegCorreoTrab" required
                :error-messages="ApoSegCorreoTrabError" @input="$v.ApoSegCorreoTrab.$touch()"
                @blur="$v.ApoSegCorreoTrab.$touch()">
              </v-text-field>
            </v-col>
            <v-col cols="12" class="user_register_container_title" style="font-size: 20px;">
              PORFAVOR SIRVASE COMPLETAR
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field filled label="A qué clínica podría ser trasladado el/la niño(a) en caso de emergencia"
                v-model="desClinica" required :error-messages="desClinicaError" @input="$v.desClinica.$touch()"
                @blur="$v.desClinica.$touch()">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-select :items="SiNo" v-model="SalirSolo" label="¿El alumno podrá salir solo?" filled return-object
                item-text="name" required :error-messages="SalirSoloError" @input="$v.SalirSolo.$touch()"
                @blur="$v.SalirSolo.$touch()">
              </v-select>
            </v-col>
            <v-col cols="12" class="user_register_container_title" style="font-size: 20px;" v-if="SalirSolo === 0">
              Sírvase indicar los datos personales de la persona que recogerá a
              su hijo(a):
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="VerPersonaRecoge">
              <v-text-field filled label="Persona 1 - Nombres y apellidos" v-model="NombreCompletoRecog" required>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="VerPersonaRecoge">
              <v-select :items="documentTypeList" v-model="TipoDocRecog" label="Persona 1 - Tipo de documento" filled
                return-object item-text="name" required>
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="VerPersonaRecoge">
              <v-text-field filled label="Persona 1 - Número de documento" v-model="DNIRecog" required>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="VerPersonaRecoge">
              <v-text-field filled label="Persona 1 - Celular" v-model="TelefonoRecog" required>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="VerPersonaRecoge">
              <v-text-field filled label="Persona 2 - Nombres y apellidos" v-model="NombreCompletoRecogSeg" required>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="VerPersonaRecoge">
              <v-select :items="documentTypeList" v-model="TipoDocRecogSeg" label="Persona 2 - Tipo de documento" filled
                return-object item-text="name" required>
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="VerPersonaRecoge">
              <v-text-field filled label="Persona 2 - Número de documento" v-model="DNIRecogSeg" required>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="VerPersonaRecoge">
              <v-text-field filled label="Persona 2 - Celular" v-model="TelefonoRecogSeg" required>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-select :items="SiNo" v-model="sufreEnfermedad"
                label="¿Su hijo(a) sufre alguna enfermedad o es alérgico a algún medicamento?" filled return-object
                item-text="name" required :error-messages="sufreEnfermedadError" @input="$v.sufreEnfermedad.$touch()"
                @blur="$v.sufreEnfermedad.$touch()">
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="6" v-if="VerSufreEnfermedad">
              <v-text-field filled label="¿Qué medicamento?" v-model="medicamento" required>
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
    <div>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" class="text-end d-flex justify-end align-center">
          <div class="return_step_top">
            <span class="selected" @click="back()">
              <v-icon style="cursor: pointer">keyboard_arrow_left</v-icon>Anterior
            </span>
          </div>
          <v-btn color="primary" class="btn-basic uppercase" @click="complete()" :loading="loading">Continuar</v-btn>
        </v-col>
      </v-row>
    </div>
    <v-snackbar v-model="snackbar" :color="colorSnackbar" :timeout="timeout" bottom left>
      <img src="./../assets/images/info-white.svg" style="margin-right:15px" alt />
      {{ textNotification }}
      <v-btn style="position: relative;bottom: 12px;" text icon color="primary" @click="snackbar = false">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import axios from "@/axios-auth";
import { mapMutations } from "vuex";
//import VuePerfectScrollbar from "vue-perfect-scrollbar";
import FormMessage from "@/components/common/FormMessage";
import moment from "moment";
moment.locale("es-do");

const { required, email } = require("vuelidate/lib/validators");

export default {
  components: {
    //VuePerfectScrollbar,
    "form-message": FormMessage
  },
  props: ["dataUsuarioMenor", "isMinor"],
  data: vm => {
    return {
      snackbar: false,
      colorSnackbar: "#2C2C2C",
      textNotification: "",
      timeout: 5000,
      userDetail: null,
      loading: false,
      UsuarioRed: null,
      PrimerNombre: "",
      SegundoNombre: "",
      apellidoPaterno: "",
      apellidoMaterno: "",
      Genero: "",
      TipoDocumentoIdentidad: "",
      DocumentoIdentidad: null,
      tipoVia: null,
      tiposVia: null,
      Direccion1: null,
      Direccion: null,
      provincia: null,
      provincias: [{ Key: "0", Value: "Seleccionar" }],
      distrito: null,
      distritos: [{ Key: "0", Value: "Seleccionar" }],
      departamentos: null,
      departamento: null,
      ApoCelular: null,
      ApoTelefono: null,
      ApoSegCelular: null,
      CorreoPersonal: null,
      ColegioMen: null,
      //datos padre
      NombreResponsable: null,
      primerNombrePadre: null,
      segundoNombrePadre: null,
      apellidoPaternoPadre: null,
      apellidoMaternoPadre: null,
      ApoGenero: null,
      ApoTipoDoc: null,
      DNIPadreFamilia: null,
      ApoCorreoPer: null,
      ApoCorreoTrab: null,
      //otro apoderado
      ApoSegNombreResponsable: null,
      primerNombreApoderado: null,
      segundoNombreApoderado: null,
      apellidoMaternoApoderado: null,
      apellidoPaternoApoderado: null,
      ApoSegGenero: null,
      ApoSegTipoDoc: null,
      ApoSegDNIResponsable: null,
      ApoSegCorreoPer: null,
      ApoSegCorreoTrab: null,

      maxDate: moment().format("YYYY-MM-DD"),
      message: null,

      fechaNacimiento2: null,
      apoFechNac2: null,
      apoSegFechNac2: null,

      fechaNacimientoFormatted: null,
      apoFechNacFormatted: null,
      apoSegFechNacFormatted: null,

      desClinica: "",
      VerPersonaRecoge: false,
      SalirSolo: null,

      NombreCompletoRecog: "",
      TipoDocRecog: null,
      DNIRecog: "",
      TelefonoRecog: "",

      NombreCompletoRecogSeg: "",
      TipoDocRecogSeg: null,
      DNIRecogSeg: "",
      TelefonoRecogSeg: null,

      sufreEnfermedad: null,
      VerSufreEnfermedad: false,
      medicamento: "",

      menu1: false,
      menu2: false,
      menu3: false,

      documentTypeList: [
        { id: 1, code: "DNI", name: "DNI" },
        { id: 2, code: "CE", name: "Carnet de extranjería" },
        { id: 3, code: "Pasaporte", name: "Pasaporte" },
        { id: 4, code: "Libreta Electoral", name: "Libreta Electoral" }
      ],
      genderList: [
        { id: 1, name: "Masculino" },
        { id: 2, name: "Femenino" }
      ],
      SiNo: [
        { id: 1, name: "Si" },
        { id: 0, name: "No" }
      ],
      datosMenor: null
    };
  },
  mixins: [validationMixin],
  validations: {
    fechaNacimiento2: { required },
    apoFechNac2: { required },
    apoSegFechNac2: { required },
    tipoVia: { required },
    Direccion1: { required },
    distrito: { required },
    provincia: { required },
    departamento: { required },
    ApoCelular: { required },
    ApoTelefono: { required },
    ApoSegCelular: { required },
    CorreoPersonal: { required, email },
    ColegioMen: { required },
    primerNombrePadre: { required },
    segundoNombrePadre: { required },
    apellidoPaternoPadre: { required },
    apellidoMaternoPadre: { required },
    ApoGenero: { required },
    ApoTipoDoc: { required },
    DNIPadreFamilia: { required },
    ApoCorreoPer: { required, email },
    ApoCorreoTrab: { required, email },

    primerNombreApoderado: { required },
    segundoNombreApoderado: { required },
    apellidoPaternoApoderado: { required },
    apellidoMaternoApoderado: { required },
    ApoSegGenero: { required },
    ApoSegTipoDoc: { required },
    ApoSegDNIResponsable: { required },
    ApoSegCorreoPer: { required, email },
    ApoSegCorreoTrab: { required, email },
    ApoFechNac: { required },
    ApoSegFechNac: { required },
    desClinica: { required },

    SalirSolo: { required },
    NombreCompletoRecog: { required },
    TipoDocRecog: { required },
    DNIRecog: { required },
    TelefonoRecog: { required },
    NombreCompletoRecogSeg: { required },
    TipoDocRecogSeg: { required },
    DNIRecogSeg: { required },
    TelefonoRecogSeg: { required },

    sufreEnfermedad: { required }
  },
  created() {
    this.userDetail = this.$store.state.usuario;
    this.Direccion = new Object();
  },
  async mounted() {
    await this.listarDepartamentos();
    this.tiposVia = await this.listarTipoVia();

    this.UsuarioRed = this.$store.state.usuario.username;

    let informacionAlumnoMenor = await this.obtenerDataMenor(this.UsuarioRed);
    let {
      PrimerNombre,
      SegundoNombre,
      apellidoPaterno,
      apellidoMaterno,
      Genero,
      FechaNacimiento,
      TipoDocumentoIdentidad,
      DocumentoIdentidad,
      Direccion,
      ApoCelular,
      ApoTelefono,
      ApoSegCelular,
      CorreoPersonal,
      ColegioMen,
      NombreResponsable,
      ApoGenero,
      ApoFechNac,
      ApoTipoDoc,
      DNIPadreFamilia,
      ApoCorreoPer,
      ApoCorreoTrab,
      ApoSegNombreResponsable,
      ApoSegGenero,
      ApoSegFechNac,
      ApoSegTipoDoc,
      ApoSegDNIResponsable,
      ApoSegCorreoPer,
      ApoSegCorreoTrab,

      NombreCompletoRecog,
      TipoDocRecog,
      DNIRecog,
      TelefonoRecog,

      NombreCompletoRecogSeg,
      TipoDocRecogSeg,
      DNIRecogSeg,
      TelefonoRecogSeg,
      desClinica,
      AlumnoSalirSolo,
      enfermedadMedicamento,
      desEnfermedadMedicamento
    } = informacionAlumnoMenor;
    this.PrimerNombre = PrimerNombre;
    this.SegundoNombre = SegundoNombre;
    this.apellidoPaterno = apellidoPaterno;
    this.apellidoMaterno = apellidoMaterno;
    this.Genero = this.genderList.find(o => o.id == Genero);

    const fechNac = new Date(FechaNacimiento);
    this.fechaNacimientoFormatted = moment(fechNac).format("DD/MM/YYYY");

    this.TipoDocumentoIdentidad = TipoDocumentoIdentidad;
    if (TipoDocumentoIdentidad) {
      this.TipoDocumentoIdentidad = this.documentTypeList.find(
        o => o.code == TipoDocumentoIdentidad
      );
    }
    this.DocumentoIdentidad = DocumentoIdentidad;

    let vias = JSON.parse(JSON.stringify(this.tiposVia));
    this.tipoVia = vias.find(o => o.Key == Direccion.TipoVia);

    this.Direccion1 = Direccion.Direccion1 === "-" ? "" : Direccion.Direccion1;
    let dptos = JSON.parse(JSON.stringify(this.departamentos));
    this.departamento = dptos.find(o => o.Key == Direccion.Departamento);
    await this.listarProvinciaPorDepartamento(this.departamento.Key);
    let prvcs = JSON.parse(JSON.stringify(this.provincias));
    this.provincia = prvcs.find(o => o.Key == Direccion.Provincia);
    await this.listarDistritoPorProvincia(this.provincia.Key);
    let dstos = JSON.parse(JSON.stringify(this.distritos));
    this.distrito = dstos.find(o => o.Key == Direccion.Distrito);
    this.ApoCelular = ApoCelular;
    this.ApoTelefono = ApoTelefono;
    this.ApoSegCelular = ApoSegCelular;
    this.CorreoPersonal = CorreoPersonal;
    this.ColegioMen = ColegioMen;
    // responsable
    if (NombreResponsable) {
      this.NombreResponsable = NombreResponsable;
    }
    this.ApoGenero = this.genderList.find(o => o.id == ApoGenero);
    if (ApoFechNac) {
      const apoFechNac = new Date(ApoFechNac);
      this.apoFechNacFormatted = moment(apoFechNac).format("DD/MM/YYYY");
    }
    if (ApoTipoDoc) {
      this.ApoTipoDoc = this.documentTypeList.find(o => o.code == ApoTipoDoc);
    }
    this.DNIPadreFamilia = DNIPadreFamilia;
    this.ApoCorreoPer = ApoCorreoPer;
    this.ApoCorreoTrab = ApoCorreoTrab ? ApoCorreoTrab : null;
    //Segundo apoderado
    if (ApoSegNombreResponsable) {
      this.ApoSegNombreResponsable = ApoSegNombreResponsable;
    }
    this.ApoSegGenero = this.genderList.find(o => o.id == ApoSegGenero);
    if (ApoSegFechNac) {
      const apoSegFechNac = new Date(ApoSegFechNac);
      this.apoSegFechNacFormatted = moment(apoSegFechNac).format("DD/MM/YYYY");
    }
    if (ApoSegTipoDoc) {
      this.ApoSegTipoDoc = this.documentTypeList.find(
        o => o.code == ApoSegTipoDoc
      );
    }
    this.ApoSegDNIResponsable = ApoSegDNIResponsable;
    this.ApoSegCorreoPer = ApoSegCorreoPer;
    this.ApoSegCorreoTrab = ApoSegCorreoTrab;

    this.NombreCompletoRecog = NombreCompletoRecog;
    ///////////////////
    if (TipoDocRecog) {
      this.TipoDocRecog = this.documentTypeList.find(
        o => o.code == TipoDocRecog
      );
    }
    this.DNIRecog = DNIRecog;
    this.TelefonoRecog = TelefonoRecog;

    this.NombreCompletoRecogSeg = NombreCompletoRecogSeg;
    ///////////////////
    if (TipoDocRecogSeg) {
      this.TipoDocRecogSeg = this.documentTypeList.find(
        o => o.code == TipoDocRecogSeg
      );
    }
    this.DNIRecogSeg = DNIRecogSeg;
    this.TelefonoRecogSeg = TelefonoRecogSeg;

    this.desClinica = desClinica;
    //this.SalirSolo === 0 ? "no" : "si"
    if (AlumnoSalirSolo) {
      let salirSolo = AlumnoSalirSolo === "si" ? 1 : 0;
      this.SalirSolo = this.SiNo.find(o => o.id == salirSolo);
    }
    if (enfermedadMedicamento) {
      let sufre = enfermedadMedicamento === "si" ? 1 : 0;
      this.sufreEnfermedad = this.SiNo.find(o => o.id == sufre);
    }
    this.medicamento = desEnfermedadMedicamento;
  },
  methods: {
    ...mapMutations(["setUserData", "setResultRegister"]),

    formatFechaNacimiento2(fechaNacimiento2) {
      if (!fechaNacimiento2) return null;
      const [year, month, day] = fechaNacimiento2.split("-");
      return `${day}/${month}/${year}`;
    },
    formatApoFechNac2(apoFechNac2) {
      if (!apoFechNac2) return null;
      const [year, month, day] = apoFechNac2.split("-");
      return `${day}/${month}/${year}`; // <- listo
    },
    formatApoSegFechNac2(apoSegFechNac2) {
      if (!apoSegFechNac2) return null;
      const [year, month, day] = apoSegFechNac2.split("-");
      return `${day}/${month}/${year}`; // <- listo
    },
    messageClose() {
      this.message = null;
    },
    submit() {
      this.$v.$touch();

      if (!this.$v.$invalid && this.checkBoxTerms) {
        this.registerUser();
      }
    },
    saldraSolo() {
      if (!this.SalirSolo) {
        return false;
      }
      if (this.SalirSolo.id === 1) {
        return true;
      } else {
        return false;
      }
    },
    estaSufriendoEnfermedad() {
      if (!this.sufreEnfermedad) {
        return false;
      }
      if (this.sufreEnfermedad.id === 1) {
        return true;
      } else {
        return false;
      }
    },
    actualizar() {
      this.loading = true;

      let nombreResponsable = null;
      if (!this.NombreResponsable) {
        nombreResponsable = `${this.primerNombrePadre} ${this.segundoNombrePadre} ${this.apellidoPaternoPadre} ${this.apellidoMaternoPadre}`;
      } else {
        nombreResponsable = this.NombreResponsable;
      }
      let nombreSegResponsable = null;
      if (!this.ApoSegNombreResponsable) {
        nombreSegResponsable = `${this.primerNombreApoderado} ${this.segundoNombreApoderado} ${this.apellidoPaternoApoderado} ${this.apellidoMaternoApoderado}`;
      } else {
        nombreSegResponsable = this.ApoSegNombreResponsable;
      }
      let data = {
        UsuarioRed: this.UsuarioRed,
        PrimerNombre: this.PrimerNombre,
        SegundoNombre: this.SegundoNombre,
        apellidoPaterno: this.apellidoPaterno,
        apellidoMaterno: this.apellidoMaterno,
        apellidos: `${this.apellidoPaterno} ${this.apellidoMaterno}`,
        TipoDocumentoIdentidad: this.TipoDocumentoIdentidad.code,
        DocumentoIdentidad: this.DocumentoIdentidad,
        Genero: this.Genero.id,
        FechaNacimiento: this.fechaNacimientoFormatted,
        Direccion: {
          Direccion1: this.Direccion1,
          Departamento: parseInt(this.departamento.Key),
          Provincia: parseInt(this.provincia.Key),
          Distrito: parseInt(this.distrito.Key),
          idTipoDireccion: 6,
          idDireccion: 0,
          TipoVia: this.tipoVia.Key
        },
        CorreoPersonal: this.CorreoPersonal,
        ColegioMen: this.ColegioMen,
        ApoCelular: this.ApoCelular,
        ApoTelefono: this.ApoTelefono,
        ApoSegCelular: this.ApoSegCelular,
        NombreResponsable: nombreResponsable,
        ApoGenero: this.ApoGenero == "Masculino" ? 1 : 2,
        ApoFechNac: this.apoFechNacFormatted,
        ApoTipoDoc: this.ApoTipoDoc.code,
        TipoDocPadre: this.ApoTipoDoc.code,
        DNIPadreFamilia: this.DNIPadreFamilia,
        ApoCorreoPer: this.ApoCorreoPer,
        ApoCorreoTrab: this.ApoCorreoTrab,
        ApoSegNombreResponsable: nombreSegResponsable,
        ApoSegGenero: this.ApoSegGenero == "Masculino" ? 1 : 2,
        ApoSegFechNac: this.apoSegFechNacFormatted,
        ApoSegTipoDoc: this.ApoSegTipoDoc.code,
        ApoSegDNIResponsable: this.ApoSegDNIResponsable,
        ApoSegCorreoPer: this.ApoSegCorreoPer,
        ApoSegCorreoTrab: this.ApoSegCorreoTrab,
        desClinica: this.desClinica,
        enfermedadMedicamento: this.sufreEnfermedad.id === 0 ? "no" : "si",
        desEnfermedadMedicamento: this.estaSufriendoEnfermedad()
          ? this.medicamento
          : "",
        AlumnoSalirSolo: this.SalirSolo.id === 0 ? "no" : "si",

        NombreCompletoRecog:
          this.saldraSolo() === false ? this.NombreCompletoRecog : "",
        TipoDocRecog: this.saldraSolo() === false ? this.TipoDocRecog.code : "",
        DNIRecog: this.saldraSolo() === false ? this.DNIRecog : "",
        TelefonoRecog: this.saldraSolo() === false ? this.TelefonoRecog : "",

        NombreCompletoRecogSeg:
          this.saldraSolo() === false ? this.NombreCompletoRecogSeg : "",
        TipoDocRecogSeg:
          this.saldraSolo() === false ? this.TipoDocRecogSeg.code : "",
        DNIRecogSeg: this.saldraSolo() === false ? this.DNIRecogSeg : "",
        TelefonoRecogSeg:
          this.saldraSolo() === false ? this.TelefonoRecogSeg : "",
        ciaTelefono: "",
        EstadoMarital: 11,
        numHijos: "",
        profesion: "",
        distritoLaboral: "",
        ApoEstadoCivil: "",
        ApoNuHijos: "",
        ApoOperadorTelf: "",
        ApoProfesion: "",
        ApoDistritoTrab: "",
        ComoEnteroCurso: "",
        Convenio: "",
        familiarUP: "",
        nivelEstudios: "",
        exAlumno: "",
        otroCentroIdiomas: "",
        CentroIdiomAnterior: "",
        ApoSegTelefono: ""
      };
      axios({
        method: "post",
        url: `users/actualizar-menor/`,
        data: data,
        headers: {
          Authorization: "Token " + this.userDetail.token
        }
      })
        .then(response => {
          console.info("actualizado");
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
      return true;
    },
    enableButton() {
      this.read = true;
    },
    verifyLocked() {
      return this.read ? "" : "locked_button";
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-z\s]+$/.test(char)) return true;
      else e.preventDefault();
    },
    isNumber() { },

    isPhoneNumber(e, dato) {
      if (!dato) {
        dato = "";
      }
      let char = String.fromCharCode(e.keyCode); // Get the character
      let selection = window
        .getSelection()
        .toString()
        .trim();
      if (selection.length > 0 && selection === dato) {
        dato = "";
      }
      if ((dato.length == 0 && char != 9) || dato.length == 9) {
        e.preventDefault();
      }
      if (/^[0-9]*$/.test(char)) return true;
      else e.preventDefault();
    },
    isDocument(e, dato, tipo) {
      if (!tipo) {
        e.preventDefault();
      }
      if (!dato) {
        dato = "";
      }
      let char = String.fromCharCode(e.keyCode);
      let selection = window
        .getSelection()
        .toString()
        .trim();
      if (selection.length > 0 && selection === dato) {
        dato = "";
      }
      if (tipo) {
        if (tipo.id == 1 || tipo.id == 4) {
          // dni
          if (dato.length == 8) e.preventDefault();

          if (/^[0-9][0-9]*$/.test(char)) return true;
          else e.preventDefault();
        } else if (tipo.id == 2 || tipo.id == 3) {
          if (dato.length >= 12) e.preventDefault();
        } else {
          if (/^[0-9][0-9]*$/.test(char)) return true;
          else e.preventDefault();
        }
      } else {
        if (/^[0-9][0-9]*$/.test(char)) return true;
        else e.preventDefault();
      }
    },
    async obtenerDataMenor(usuarioRed) {
      this.loading = true;
      let datos = await axios({
        method: "post",
        url: `users/obtener-menor/`,
        data: {
          usuarioRed: usuarioRed
        },
        headers: {
          Authorization: "Token " + this.userDetail.token
        }
      })
        .then(response => {
          this.datosMenor = response.data.detail;
          this.loading = false;
          return response.data.detail;
        })
        .catch(err => {
          this.loading = true;
        });
      return datos;
    },
    async listarTipoVia() {
      let tiposVia = await axios({
        method: "post",
        url: `users/listar-tipo-via/`,
        headers: {
          Authorization: "Token " + this.userDetail.token
        }
      })
        .then(response => {
          return response.data.detail;
        })
        .catch(e => {
          console.error(e);
        });
      return tiposVia;
    },
    async listarDepartamentos() {
      this.departamentos = await axios({
        method: "post",
        url: `users/listar-departamento-por-id-pais/`,
        data: {
          codigo: "0"
        },
        headers: {
          Authorization: "Token " + this.userDetail.token
        }
      })
        .then(response => {
          return response.data.detail;
        })
        .catch(e => {
          console.error(e);
        });
    },
    async listarProvinciaPorDepartamento(idDepartamento) {
      this.provincias = await axios({
        method: "post",
        url: `users/listar-provincia-por-id-departamento/`,
        data: {
          codigo: idDepartamento
        },
        headers: {
          Authorization: "Token " + this.userDetail.token
        }
      })
        .then(response => {
          return response.data.detail;
        })
        .catch(e => {
          console.error(e);
        });
    },
    async listarDistritoPorProvincia(idProvincia) {
      this.distritos = await axios({
        method: "post",
        url: `users/listar-distrito-por-id-provincia/`,
        data: {
          codigo: idProvincia
        },
        headers: {
          Authorization: "Token " + this.userDetail.token
        }
      })
        .then(response => {
          return response.data.detail;
        })
        .catch(e => {
          console.error(e);
        });
    },
    disableContinue() {
      return false;
    },
    goToStep(n) {
      // if (this.disableContinue()) {
      //   return;
      // }

      this.$emit("goToStep", n);
      // if (!this.defaultSection.course_amount) {
      //   this.$router.push("/principal");
      // } else {
      //   this.$emit("goToStep", n);
      // }
    },
    complete() {
      if (this.validarRegistro()) {
        this.$v.$touch();
        return;
      }

      if (!this.saldraSolo()) {
        if (!this.NombreCompletoRecog) {
          this.textNotification =
            "Nombre de primera persona que recoge no es válido";
          this.loading = false;
          this.snackbar = true;
          this.$v.$touch();
          return;
        }
        if (!this.TipoDocRecog) {
          this.textNotification =
            "Tipo documento de primera persona que recoge no es válido";
          this.loading = false;
          this.snackbar = true;
          this.$v.$touch();
          return;
        }
        if (!this.DNIRecog) {
          this.textNotification =
            "Documento de primera persona que recoge no es válido";
          this.loading = false;
          this.snackbar = true;
          this.$v.$touch();
          return;
        }
        if (!this.TelefonoRecog) {
          this.textNotification =
            "Teléfono de primera persona que recoge no es válido";
          this.loading = false;
          this.snackbar = true;
          this.$v.$touch();
          return;
        }
        if (!this.NombreCompletoRecogSeg) {
          this.textNotification =
            "Nombre de segunda persona que recoge no es válido";
          this.loading = false;
          this.snackbar = true;
          this.$v.$touch();
          return;
        }
        if (!this.TipoDocRecogSeg) {
          this.textNotification =
            "Tipo documento de segunda persona que recoge no es válido";
          this.loading = false;
          this.snackbar = true;
          this.$v.$touch();
          return;
        }
        if (!this.DNIRecogSeg) {
          this.textNotification =
            "Documento de segunda persona que recoge no es válido";
          this.loading = false;
          this.snackbar = true;
          this.$v.$touch();
          return;
        }
        if (!this.TelefonoRecogSeg) {
          this.textNotification =
            "Teléfono de segunda persona que recoge no es válido";
          this.loading = false;
          this.snackbar = true;
          this.$v.$touch();
          return;
        }
      }
      if (this.estaSufriendoEnfermedad()) {
        if (!this.medicamento) {
          this.textNotification =
            "Tiene que ingresar el nombre del medicamento";
          this.loading = false;
          this.snackbar = true;
          this.$v.$touch();
          return;
        }
      }

      // this.textNotification = "Actualizando";
      // this.loading = false;
      // this.snackbar = true;
      let retorno = this.actualizar();
      if (retorno !== "no") {
        this.goToStep(2);
      }
    },
    back() {
      this.$router.push("/principal");
    },
    validarRegistro() {
      if (this.$v.tipoVia.$invalid ){
          console.log('this.$v.tipoVia.$invalid:')
          console.log(this.$v.tipoVia.$invalid)
        return true;
      }
      if (this.$v.Direccion1.$invalid ){
          console.log('this.$v.Direccion1.$invalid:')
          console.log(this.$v.Direccion1.$invalid)
        return true;
      }
      if (this.$v.departamento.$invalid ){
          console.log('this.$v.departamento.$invalid:')
          console.log(this.$v.departamento.$invalid)
        return true;
      }
      if (this.$v.provincia.$invalid ){
          console.log('this.$v.provincia.$invalid:')
          console.log(this.$v.provincia.$invalid)
        return true;
      }
      if (this.$v.distrito.$invalid ){
          console.log('this.$v.distrito.$invalid:')
          console.log(this.$v.distrito.$invalid)
        return true;
      }
      if (this.$v.ApoCelular.$invalid ){
          console.log('this.$v.ApoCelular.$invalid:')
          console.log(this.$v.ApoCelular.$invalid)
        return true;
      }
      if (this.$v.ApoTelefono.$invalid ){
          console.log('this.$v.ApoTelefono.$invalid:')
          console.log(this.$v.ApoTelefono.$invalid)
        return true;
      }
      if (this.$v.ApoSegCelular.$invalid ){
          console.log('this.$v.ApoSegCelular.$invalid:')
          console.log(this.$v.ApoSegCelular.$invalid)
        return true;
      }
      if (this.$v.CorreoPersonal.$invalid ){
          console.log('this.$v.CorreoPersonal.$invalid:')
          console.log(this.$v.CorreoPersonal.$invalid)
        return true;
      }
      if (this.$v.ColegioMen.$invalid ){
          console.log('this.$v.ColegioMen.$invalid:')
          console.log(this.$v.ColegioMen.$invalid)
        return true;
      }
      if (!this.NombreResponsable) {
        if (this.$v.primerNombrePadre.$invalid ){
          console.log('this.$v.primerNombrePadre.$invalid:')
          console.log(this.$v.primerNombrePadre.$invalid)
          return true;
        }
        if (this.$v.segundoNombrePadre.$invalid ){
            console.log('this.$v.segundoNombrePadre.$invalid:')
            console.log(this.$v.segundoNombrePadre.$invalid)
          return true;
        }
        if (this.$v.apellidoPaternoPadre.$invalid ){
            console.log('this.$v.apellidoPaternoPadre.$invalid:')
            console.log(this.$v.apellidoPaternoPadre.$invalid)
          return true;
        }
        if (this.$v.apellidoMaternoPadre.$invalid ){
            console.log('this.$v.apellidoMaternoPadre.$invalid:')
            console.log(this.$v.apellidoMaternoPadre.$invalid)
          return true;
        }
      }
      
      if (this.$v.ApoGenero.$invalid ){
          console.log('this.$v.ApoGenero.$invalid:')
          console.log(this.$v.ApoGenero.$invalid)
        return true;
      }
      if (this.$v.apoFechNac2.$invalid && !this.apoFechNacFormatted ){
          console.log('this.$v.apoFechNac2.$invalid:')
          console.log(this.$v.apoFechNac2.$invalid)
        return true;
      }
      if (this.$v.ApoTipoDoc.$invalid ){
          console.log('this.$v.ApoTipoDoc.$invalid:')
          console.log(this.$v.ApoTipoDoc.$invalid)
        return true;
      }
      if (this.$v.DNIPadreFamilia.$invalid ){
          console.log('this.$v.DNIPadreFamilia.$invalid:')
          console.log(this.$v.DNIPadreFamilia.$invalid)
        return true;
      }
      if (this.$v.ApoCorreoPer.$invalid ){
          console.log('this.$v.ApoCorreoPer.$invalid:')
          console.log(this.$v.ApoCorreoPer.$invalid)
        return true;
      }
      if (this.$v.ApoCorreoTrab.$invalid ){
          console.log('this.$v.ApoCorreoTrab.$invalid:')
          console.log(this.$v.ApoCorreoTrab.$invalid)
        return true;
      }
      if (!this.ApoSegNombreResponsable) {
        if (this.$v.primerNombreApoderado.$invalid ){
          console.log('this.$v.primerNombreApoderado.$invalid:')
          console.log(this.$v.primerNombreApoderado.$invalid)
          return true;
        }
        if (this.$v.segundoNombreApoderado.$invalid ){
            console.log('this.$v.segundoNombreApoderado.$invalid:')
            console.log(this.$v.segundoNombreApoderado.$invalid)
          return true;
        }
        if (this.$v.apellidoPaternoApoderado.$invalid ){
            console.log('this.$v.apellidoPaternoApoderado.$invalid:')
            console.log(this.$v.apellidoPaternoApoderado.$invalid)
          return true;
        }
        if (this.$v.apellidoMaternoApoderado.$invalid ){
            console.log('this.$v.apellidoMaternoApoderado.$invalid:')
            console.log(this.$v.apellidoMaternoApoderado.$invalid)
          return true;
        }
      }
      if (this.$v.ApoSegGenero.$invalid ){
          console.log('this.$v.ApoSegGenero.$invalid:')
          console.log(this.$v.ApoSegGenero.$invalid)
        return true;
      }
      if (this.$v.apoSegFechNac2.$invalid && !this.apoSegFechNacFormatted ){
          console.log('this.$v.apoSegFechNac2.$invalid:')
          console.log(this.$v.apoSegFechNac2.$invalid)
        return true;
      }
      if (this.$v.ApoSegTipoDoc.$invalid ){
          console.log('this.$v.ApoSegTipoDoc.$invalid:')
          console.log(this.$v.ApoSegTipoDoc.$invalid)
        return true;
      }
      if (this.$v.ApoSegDNIResponsable.$invalid ){
          console.log('this.$v.ApoSegDNIResponsable.$invalid:')
          console.log(this.$v.ApoSegDNIResponsable.$invalid)
        return true;
      }
      if (this.$v.ApoSegCorreoPer.$invalid ){
          console.log('this.$v.ApoSegCorreoPer.$invalid:')
          console.log(this.$v.ApoSegCorreoPer.$invalid)
        return true;
      }
      if (this.$v.ApoSegCorreoTrab.$invalid ){
          console.log('this.$v.ApoSegCorreoTrab.$invalid:')
          console.log(this.$v.ApoSegCorreoTrab.$invalid)
        return true;
      }
      if (this.$v.desClinica.$invalid ){
          console.log('this.$v.desClinica.$invalid:')
          console.log(this.$v.desClinica.$invalid)
        return true;
      }
      if (this.$v.SalirSolo.$invalid ){
          console.log('this.$v.SalirSolo.$invalid:')
          console.log(this.$v.SalirSolo.$invalid)
        return true;
      }
      if (this.$v.sufreEnfermedad.$invalid ){
          console.log('this.$v.sufreEnfermedad.$invalid:')
          console.log(this.$v.sufreEnfermedad.$invalid)
        return true;
      } else return false;
    }
  },
  watch: {
    documentType(val) {
      if (val) {
        this.documentNumber = "";
        this.$refs.documentNumber.focus();
      }
    },
    fechaNacimiento2(val) {
      this.fechaNacimientoFormatted = this.formatFechaNacimiento2(
        val
      );
    },
    apoFechNac2(val) {
      this.apoFechNacFormatted = this.formatApoFechNac2(val);
    },
    apoSegFechNac2(val) {
      this.apoSegFechNacFormatted = this.formatApoSegFechNac2(
        val
      );
    },
    async departamento(val) {
      if (val) {
        this.listarProvinciaPorDepartamento(val.Key);
      }
    },
    async provincia(val) {
      if (val) {
        this.listarDistritoPorProvincia(val.Key);
      }
    },
    SalirSolo(val) {
      if (val.id === 0) {
        this.VerPersonaRecoge = true;
      } else {
        this.VerPersonaRecoge = false;
      }
    },
    sufreEnfermedad(val) {
      if (val.id === 0) {
        this.VerSufreEnfermedad = false;
      } else {
        this.VerSufreEnfermedad = true;
      }
    }
  },
  computed: {
    genderError() {
      const errors = [];
      if (!this.$v.gender.$dirty) return errors;
      !this.$v.gender.required && errors.push("Este dato es requerido.");
      return errors;
    },
    tipoViaError() {
      const errors = [];
      if (!this.$v.tipoVia.$dirty) return errors;
      !this.$v.tipoVia.required && errors.push("Este dato es requerido.");
      return errors;
    },
    Direccion1Error() {
      const errors = [];
      if (!this.$v.Direccion1.$dirty) return errors;
      !this.$v.Direccion1.required && errors.push("Este dato es requerido.");
      return errors;
    },
    distritoError() {
      const errors = [];
      if (!this.$v.distrito.$dirty) return errors;
      !this.$v.distrito.required && errors.push("Este dato es requerido.");
      return errors;
    },
    provinciaError() {
      const errors = [];
      if (!this.$v.provincia.$dirty) return errors;
      !this.$v.provincia.required && errors.push("Este dato es requerido.");
      return errors;
    },
    departamentoError() {
      const errors = [];
      if (!this.$v.departamento.$dirty) return errors;
      !this.$v.departamento.required && errors.push("Este dato es requerido.");
      return errors;
    },
    ApoCelularError() {
      const errors = [];
      if (!this.$v.ApoCelular.$dirty) return errors;
      !this.$v.ApoCelular.required && errors.push("Este dato es requerido.");
      return errors;
    },
    ApoTelefonoError() {
      const errors = [];
      if (!this.$v.ApoTelefono.$dirty) return errors;
      !this.$v.ApoTelefono.required && errors.push("Este dato es requerido.");
      return errors;
    },
    ApoSegCelularError() {
      const errors = [];
      if (!this.$v.ApoSegCelular.$dirty) return errors;
      !this.$v.ApoSegCelular.required && errors.push("Este dato es requerido.");
      return errors;
    },
    fechaNacimientoError() {
      const errors = [];
      if (!this.$v.fechaNacimiento2.$dirty) return errors;
      !this.$v.fechaNacimiento2 == null &&
        errors.push("Este dato es requerido.");
      !this.$v.fechaNacimiento2.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    apoFechNacError() {
      const errors = [];
      if (!this.$v.apoFechNac2.$dirty) return errors;
      !this.$v.apoFechNac2 == null && errors.push("Este dato es requerido.");
      !this.$v.apoFechNac2.required && errors.push("Este dato es requerido.");
      return errors;
    },
    apoSegFechNacError() {
      const errors = [];
      if (!this.$v.apoSegFechNac2.$dirty) return errors;
      !this.$v.apoSegFechNac2 == null && errors.push("Este dato es requerido.");
      !this.$v.apoSegFechNac2.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    CorreoPersonalError() {
      const errors = [];
      if (!this.$v.CorreoPersonal.$dirty) return errors;
      !this.$v.CorreoPersonal.email && errors.push("Ingrese un e-mail válido.");
      !this.$v.CorreoPersonal.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    ColegioMenError() {
      const errors = [];
      if (!this.$v.ColegioMen.$dirty) return errors;
      !this.$v.ColegioMen.required && errors.push("Este dato es requerido.");
      return errors;
    },
    primerNombrePadreError() {
      const errors = [];
      if (!this.$v.primerNombrePadre.$dirty) return errors;
      !this.$v.primerNombrePadre.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    segundoNombrePadreError() {
      const errors = [];
      if (!this.$v.segundoNombrePadre.$dirty) return errors;
      !this.$v.segundoNombrePadre.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    apellidoPaternoPadreError() {
      const errors = [];
      if (!this.$v.apellidoPaternoPadre.$dirty) return errors;
      !this.$v.apellidoPaternoPadre.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    apellidoMaternoPadreError() {
      const errors = [];
      if (!this.$v.apellidoMaternoPadre.$dirty) return errors;
      !this.$v.apellidoMaternoPadre.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    ApoGeneroError() {
      const errors = [];
      if (!this.$v.ApoGenero.$dirty) return errors;
      !this.$v.ApoGenero.required && errors.push("Este dato es requerido.");
      return errors;
    },
    ApoTipoDocError() {
      const errors = [];
      if (!this.$v.ApoTipoDoc.$dirty) return errors;
      !this.$v.ApoTipoDoc.required && errors.push("Este dato es requerido.");
      return errors;
    },
    DNIPadreFamiliaError() {
      const errors = [];
      if (!this.$v.DNIPadreFamilia.$dirty) return errors;
      !this.$v.DNIPadreFamilia.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    ApoCorreoPerError() {
      const errors = [];
      if (!this.$v.ApoCorreoPer.$dirty) return errors;
      !this.$v.ApoCorreoPer.email && errors.push("Ingrese un e-mail válido.");
      !this.$v.ApoCorreoPer.required && errors.push("Este dato es requerido.");
      return errors;
    },
    ApoCorreoTrabError() {
      const errors = [];
      if (!this.$v.ApoCorreoTrab.$dirty) return errors;
      !this.$v.ApoCorreoTrab.email && errors.push("Ingrese un e-mail válido.");
      !this.$v.ApoCorreoTrab.required && errors.push("Este dato es requerido.");
      return errors;
    },
    primerNombreApoderadoError() {
      const errors = [];
      if (!this.$v.primerNombreApoderado.$dirty) return errors;
      !this.$v.primerNombreApoderado.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    segundoNombreApoderadoError() {
      const errors = [];
      if (!this.$v.segundoNombreApoderado.$dirty) return errors;
      !this.$v.segundoNombreApoderado.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    apellidoPaternoApoderadoError() {
      const errors = [];
      if (!this.$v.apellidoPaternoApoderado.$dirty) return errors;
      !this.$v.apellidoPaternoApoderado.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    apellidoMaternoApoderadoError() {
      const errors = [];
      if (!this.$v.apellidoMaternoApoderado.$dirty) return errors;
      !this.$v.apellidoMaternoApoderado.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    ApoSegGeneroError() {
      const errors = [];
      if (!this.$v.ApoSegGenero.$dirty) return errors;
      !this.$v.ApoSegGenero.required && errors.push("Este dato es requerido.");
      return errors;
    },
    ApoSegTipoDocError() {
      const errors = [];
      if (!this.$v.ApoSegTipoDoc.$dirty) return errors;
      !this.$v.ApoSegTipoDoc.required && errors.push("Este dato es requerido.");
      return errors;
    },
    ApoSegDNIResponsableError() {
      const errors = [];
      if (!this.$v.ApoSegDNIResponsable.$dirty) return errors;
      !this.$v.ApoSegDNIResponsable.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    ApoSegCorreoPerError() {
      const errors = [];
      if (!this.$v.ApoSegCorreoPer.$dirty) return errors;
      !this.$v.ApoSegCorreoPer.email &&
        errors.push("Ingrese un e-mail válido.");
      !this.$v.ApoSegCorreoPer.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    ApoSegCorreoTrabError() {
      const errors = [];
      if (!this.$v.ApoSegCorreoTrab.$dirty) return errors;
      !this.$v.ApoSegCorreoTrab.email &&
        errors.push("Ingrese un e-mail válido.");
      !this.$v.ApoSegCorreoTrab.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    desClinicaError() {
      const errors = [];
      if (!this.$v.desClinica.$dirty) return errors;
      !this.$v.desClinica.required && errors.push("Este dato es requerido.");
      return errors;
    },
    SalirSoloError() {
      const errors = [];
      if (!this.$v.SalirSolo.$dirty) return errors;
      !this.$v.SalirSolo.required && errors.push("Este dato es requerido.");
      return errors;
    },
    NombreCompletoRecogError() {
      const errors = [];
      if (!this.$v.NombreCompletoRecog.$dirty) return errors;
      !this.saldraSolo() &&
        !this.$v.NombreCompletoRecog.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    TipoDocRecogError() {
      const errors = [];
      if (!this.$v.TipoDocRecog.$dirty) return errors;
      !this.saldraSolo() &&
        !this.$v.TipoDocRecog.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    DNIRecogError() {
      const errors = [];
      if (!this.$v.DNIRecog.$dirty) return errors;
      !this.saldraSolo() &&
        !this.$v.DNIRecog.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    TelefonoRecogError() {
      const errors = [];
      if (!this.$v.TelefonoRecog.$dirty) return errors;
      !this.saldraSolo() &&
        !this.$v.TelefonoRecog.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    NombreCompletoRecogSegError() {
      const errors = [];
      if (!this.$v.NombreCompletoRecogSeg.$dirty) return errors;
      !this.saldraSolo() &&
        !this.$v.NombreCompletoRecogSeg.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    TipoDocRecogSegError() {
      const errors = [];
      if (!this.$v.TipoDocRecogSeg.$dirty) return errors;
      !this.saldraSolo() &&
        !this.$v.TipoDocRecogSeg.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    DNIRecogSegError() {
      const errors = [];
      if (!this.$v.DNIRecogSeg.$dirty) return errors;
      !this.saldraSolo() &&
        !this.$v.DNIRecogSeg.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    TelefonoRecogSegError() {
      const errors = [];
      if (!this.$v.TelefonoRecogSeg.$dirty) return errors;
      !this.saldraSolo() &&
        !this.$v.TelefonoRecogSeg.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    sufreEnfermedadError() {
      const errors = [];
      if (!this.$v.sufreEnfermedad.$dirty) return errors;
      !this.$v.sufreEnfermedad.required &&
        errors.push("Este dato es requerido.");
      return errors;
    },
    isDisabled() {
      if (this.tipoViaError.length) {
        return true;
        // } else if (!this.apoFechNacError.length) {
        //   return true;
        // } else if (!this.departamentoError.length) {
        //   return true;
        // } else if (!this.provinciaError.length) {
        //   return true;
        // } else if (!this.distritoError.length) {
        //   return true;
        // } else if (!this.ApoCelularError.length) {
        //   return true;
        // } else if (!this.ApoTelefonoError.length) {
        //   return true;
        // } else if (!this.ApoSegCelularError.length) {
        //   return true;
        // } else if (!this.fechaNacimientoError.length) {
        //   return true;
        // } else if (!this.apoFechNacError.length) {
        //   return true;
        // } else if (!this.apoSegFechNacError.length) {
        //   return true;
        // } else if (!this.ColegioMenError.length) {
        //   return true;
        // } else if (!this.primerNombrePadreError.length) {
        //   return true;
        // } else if (!this.segundoNombrePadreError.length) {
        //   return true;
        // } else if (!this.apellidoPaternoPadreError.length) {
        //   return true;
        // } else if (!this.apellidoMaternoPadreError.length) {
        //   return true;
        // } else if (!this.ApoGeneroError.length) {
        //   return true;
        // } else if (!this.ApoTipoDocError.length) {
        //   return true;
        // } else if (!this.DNIPadreFamiliaError.length) {
        //   return true;
        // } else if (!this.ApoCorreoPerError.length) {
        //   return true;
      }
      return false;
    }
  }
};
</script>
